import { configureStore } from "@reduxjs/toolkit";
import player from "./reducer/playerReducer";
import currentSong from "./reducer/currentSong";
import playing from "./reducer/playing";

const store = configureStore(
  {
    reducer: { player, currentSong, playing },
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
